import actionCreatorFactory from 'typescript-fsa'
import { Account } from '@ynap/api-utils';
import { authApiActionCreatorFactory } from '../../utils/redux-thunk-fetch'

const createAction = actionCreatorFactory('address-state')
const createAuthApiAction = authApiActionCreatorFactory(createAction)

export type FetchAddressesPayload = {
    contact?: Array<{
        externalAddress?: string
        lastName: string
        primaryShipping: string
        state: string
        addressType: string
        email1: string
        phone1: string
        addressId: string
        country: string
        city: string
        addressLine: Array<string>
        primaryBilling: string
        contactStoreIdentifier: string
        nickName: string
        zipCode: string
        firstName: string
    }>
}

export type AddAddressPayload = {
    addressId: string
}

export const fetchAddresses = createAuthApiAction<FetchAddressesPayload>('FETCH_ADDRESSES')(Account.getAddresses)

export const addAddress = createAuthApiAction<AddAddressPayload>('ADD_ADDRESS')(Account.addAddress)

export const deleteAddress = createAuthApiAction<{}>('DELETE_ADDRESS')(Account.deleteAddress)

export const undoDeleteAddress = createAuthApiAction<AddAddressPayload>('UNDO_DELETE_ADDRESS')(Account.addAddress)

export const updateAddress = createAuthApiAction<AddAddressPayload>('UPDATE_ADDRESS')(Account.updateAddress)